import "./RaikoEditorHtmlEditor.scss"
import RaikoTextEditor from "../../raikoTextEditor/RaikoTextEditor";
import React, {useEffect, useState} from "react";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import {useDebounce} from "@uidotdev/usehooks";
import CustomHtmlTextEditor from "../../../component/magazine/CustomHtmlTextEditor";

export default function RaikoEditorHtmlEditor(
    {
        value = "",
        priority,
        editorValue,
        setEditorValue,
        uid
    }
) {

    const [textEditorValue, setTextEditorValue] = useState(value);
    const _textEditorValue = useDebounce(textEditorValue, 500)

    useEffect(() => {
        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(_textEditorValue, EditorItemType.HTML,uid),
            priority)
    }, [_textEditorValue])

    return (
        <div>
           {/* <CustomHtmlTextEditor
                text={value}
                setText={setTextEditorValue}
                priority={priority}
            />*/}

            <RaikoTextEditor
                text={value}
                setText={text => {
                    setTextEditorValue(text)
                }}
            />
        </div>
    )
}